import { Navigate } from "react-router";
import { useAuth } from "../../hooks/useAuth";
import FullLoading from "../FullLoading";
import Home from "../../pages/home";

export default function HomeOrRedirect() {
  const { isAuthLoading, isAuthenticated } = useAuth();

  if (isAuthLoading) {
    return <FullLoading />;
  }

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Home />;
}
